<template>
  <span
    v-if="label && textOnly"
    class="dict-tag-text-only"
    :style="tagStyle">{{ label }}</span>
  <el-tag
    v-else-if="label"
    :type="tagType"
    :style="tagStyle"
    size="small">
    {{ label }}
  </el-tag>
  <span v-else-if="showValue">{{ displayValue }}</span>
</template>

<script>
import {getDictData, getDictItem, getDictTextOnlyStyle, resolveDictTag} from '@/utils/dict';

export default {
  name: 'DictTag',
  props: {
    /** 字典编码 */
    dictCode: {
      type: String,
      required: true
    },
    /** 字典项 ID 或 code */
    value: {
      type: [String, Number],
      default: ''
    },
    /** 同一字典下的分组字段，如 order_status */
    field: {
      type: String,
      default: ''
    },
    /** 无匹配时是否显示原始值 */
    showValue: {
      type: Boolean,
      default: true
    },
    /** 纯文字展示（无背景、无边框） */
    textOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: null
    };
  },
  computed: {
    displayValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    label() {
      return this.item ? this.item.dictDataName : '';
    },
    tagMeta() {
      const listClass = this.item ? this.item.listClass : undefined;
      return resolveDictTag(listClass);
    },
    tagType() {
      return this.textOnly ? '' : this.tagMeta.type;
    },
    tagStyle() {
      if (!this.textOnly) {
        return this.tagMeta.style;
      }
      if (this.tagMeta.style && this.tagMeta.style.backgroundColor === 'transparent') {
        return this.tagMeta.style;
      }
      return getDictTextOnlyStyle(this.tagMeta.type);
    }
  },
  watch: {
    dictCode: {
      handler() {
        this.loadDict();
      },
      immediate: true
    },
    value() {
      this.syncItem();
    },
    field() {
      this.syncItem();
    }
  },
  methods: {
    loadDict() {
      if (!this.dictCode) {
        this.item = null;
        return;
      }
      getDictData(this.dictCode).then(() => {
        this.syncItem();
      }).catch(() => {
        this.item = null;
      });
    },
    syncItem() {
      this.item = getDictItem(this.dictCode, this.value, this.field);
    }
  }
};
</script>

<style scoped>
.dict-tag-text-only {
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
}
</style>

